import React,{useState,useContext} from "react";
import "../styles/Dashboard.css";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Link } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DescriptionIcon from "@mui/icons-material/Description";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import {Alert,Button} from "@mui/material";
import GroupsIcon from '@mui/icons-material/Groups';
import { StudentDetailsContext } from "../store/student-details";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
const Dashboard = () => {
  // const studentDetailsContext = useContext(StudentDetailsContext);
    const StudentContext = useContext(StudentDetailsContext);


    const[AdmissionNumber,setAdmissionNumber] = useState("");
    const[month,setMonth] = useState("January");    
    const[workingDays,setWorkingDays] = useState("");
    const[presentDays,setPresentDays] = useState("");
    const[absentDays,setAbsentDays] = useState("");
    const[showAlert,setShowAlert] = useState(true);
    function handleAttendance(e){
        // alert("")
        e.preventDefault();
        console.log(AdmissionNumber);
        console.log(month);
        console.log(workingDays);
        console.log(presentDays);
        console.log(absentDays);

        StudentContext.uploadAttendance(AdmissionNumber,month,workingDays,presentDays,absentDays);

    }
  return (
    <div className="dashboardMainDiv">
      <div className="dashboardMenu">
        <ul className="dashboardDropdownList">
          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/">
                Dashboard
              </Link>
            </li>
            <li className="listItemIcon">
              <DashboardIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/bonafide">
                Bonafide
              </Link>
            </li>
            <li className="listItemIcon">
              <ArticleIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/receipt">
                Receipt
              </Link>
            </li>
            <li className="listItemIcon">
              <ReceiptLongIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/exams">
                Exams
              </Link>
            </li>
            <li className="listItemIcon">
              <DescriptionIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/feeDetails">
                Fee Details
              </Link>
            </li>
            <li className="listItemIcon">
              <CurrencyRupeeIcon />
            </li>
          </div>

          <div className="listItemContainer activeContainer">
            <li className="listItem">
              <Link className="linkItem" to="/uploadAttendance">
                Attendance
              </Link>
            </li>
            <li className="listItemIcon">
              <GroupsIcon />
            </li>
          </div>
        </ul>
      </div>
      <div className="dashboardContent">
        <div className="container dashboardContentContainer">
          <div className="row">
          <div className="container">
                        <div className="row">
                            <div className="col-lg-10 col-sm-12 col-12 col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                    { StudentContext  && (StudentContext.isUpdated ? <>
                                       {showAlert && ( <Alert
                                        action={
                                            <Button color="inherit" size="small"
                                            onClose = {()=>setShowAlert(false)}>
                                                close

                                            </Button>
                                            }
                                        
                                        >
                                        Attendance Updated Successfully
                                        </Alert>)}
                                    </> : <></>)}
                                        <form>
                                            <div className="col-lg-12 my-3">
                                                <label className="text text-success">Admission Number</label>
                                                <input type="text" placeholder="Enter Student Admission Number" className="form-control"
                                                    onChange={(e)=>setAdmissionNumber(e.target.value)}
                                                />
                                            </div>

                                            

                                            <div className="col-lg-12 my-4">
                                                <label className="text text-success">Month</label>
                                                {/* <input type="text" placeholder="Enter Month Name" className="form-control"
                                                    onChange={(e)=>setMonth(e.target.value)}

                                                /> */}
                                                <select className="form-control"
                                                onChange={(e)=>setMonth(e.target.value)}>
                                                    <option selected
                                                    >January</option>
                                                    <option>February</option>
                                                    <option>March</option>
                                                    <option>April</option>
                                                    <option>May</option>
                                                    <option>June</option>
                                                    <option>July</option>
                                                    <option>August</option>
                                                    <option>September</option>
                                                    <option>October</option>
                                                    <option>November</option>
                                                    <option>December</option>
                                                </select>
                                            </div>

                                            <div className="col-lg-12 my-4">
                                                <label className="text text-success">Working Days</label>
                                                <input type="number" placeholder="Enter No.of Working Days" className="form-control"
                                                    onChange={(e)=>setWorkingDays(e.target.value)}

                                                />
                                            </div>

                                            <div className="col-lg-12 my-4">
                                                <label className="text text-success">Present Days</label>
                                                <input type="number" placeholder="Enter how many present" className="form-control"
                                                    onChange={(e)=>setPresentDays(e.target.value)}

                                                />
                                            </div>

                                            <div className="col-lg-12 my-4">
                                                <label className="text text-success">Absent Days</label>
                                                <input type="number" placeholder="Enter Absent Days" className="form-control"
                                                    onChange={(e)=>setAbsentDays(e.target.value)}

                                                />
                                            </div>

                                            <div className="col-lg-12 my-4">
                                                <button className="btn btn-sm btn-primary px-5 py-1"
                                                type="submit" onClick={(e)=>handleAttendance(e)}>{StudentContext && StudentContext.loading ? "Loading..":"Upload Attendance"} &nbsp; <CloudUploadIcon/></button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
           
          </div>

          
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
